import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { validate } from "./Schema";
import SingUpWihGoggle from "./SingUpWihGoggle";
import { useDispatch, useSelector } from "react-redux";
import { togRegModalToFalse } from "../../../REDUX/RegistrationModalToggle/toggleModal";
import { SignupApi } from "../../../Api/Register";
import { Font } from "../../../utils/Font";

const SignUp = () => {
  const dispatch = useDispatch();
  const { signUpLoading, currentUser, signUpError, isGettingUser } =
    useSelector((state) => state.User);

  if (signUpError) {
    console.log(signUpError);
  }
  if (currentUser) {
    console.log(currentUser);
  }

  const onSubmit = (values, action) => {
    console.log(values);
    SignupApi(dispatch, values);
  };

  const {
    values,
    handleChange,
    touched,
    errors,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validate,
    onSubmit,
  });

  function togRegModalToFalseFunction() {
    console.log("object");
    dispatch(togRegModalToFalse());
  }

  return (
    <div>
      <div className="flex justify-center mx-7 md:mx-0">
        <div className="container sm:mt-40 mt-24 my-auto max-w-md border-2 border-gray-200 p-3 bg-white rounded-2xl w-full md:w-[500px]">
          <div className="text-center my-3 relative flex items-center justify-between md:block">
            {/* <h1 className="text-2xl md:text-3xl font-semibold text-indigo-400 font-workSans">
              Join Time Shoppy
            </h1> */}
            <Font title="Join Time Shoppy" />
            <i
              onClick={togRegModalToFalseFunction}
              className="bi bi-x  right-0 top-10 text-2xl  text-red-400 hover:text-red-500 md:hidden"
            ></i>
          </div>
          <div className="m-6">
            <form className="mb-4" onSubmit={handleSubmit} method="post">
              {/* importing sing up with google button */}
              <SingUpWihGoggle />

              <div className="text-sm text-gray-600 dark:text-gray-400 text-center uppercase my-2 font-semibold">
                or
              </div>
              {/* name */}
              <div className="mb-3">
                <input
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter Full Name"
                  className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-whites border-none
                    ${
                      errors.name && touched.name
                        ? "ring-2 ring-red-600 "
                        : null
                    }
                    ${
                      touched.name && !errors.name
                        ? "ring-2 ring-[#4FF072]"
                        : null
                    }  
                    `}
                />
                {errors.name && touched.name && (
                  <small className="text-red-500">{errors.name}</small>
                )}
              </div>

              {/* email */}
              <div className="mb-3">
                <input
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Your email address"
                  className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-whites border-none
                    ${
                      errors.email && touched.email
                        ? "ring-2 ring-red-600 "
                        : null
                    }
                    ${
                      touched.email && !errors.email
                        ? "ring-2 ring-[#4FF072]"
                        : null
                    }  
                    `}
                />
                {errors?.email && touched.email && (
                  <small className="text-red-500">{errors.email}</small>
                )}
              </div>

              {/* password */}
              <div className="mb-3">
                <div className="flex justify-between mb-2"></div>
                <input
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Your password"
                  autoComplete="on"
                  className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-whites border-none
                    ${
                      errors.password && touched.password
                        ? "ring-2 ring-red-600 "
                        : null
                    }
                    ${
                      touched.password && !errors.password
                        ? "ring-2 ring-[#4FF072]"
                        : null
                    }  
                    `}
                />
                {errors?.password && touched.password && (
                  <small className="text-red-500">{errors.password}</small>
                )}
              </div>

              {/* confirm password */}
              <div className="mb-3">
                <div className="flex justify-between mb-2"></div>
                <input
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="confirm password"
                  autoComplete="on"
                  className={`w-full px-3 py-2 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500 rounded-full bg-whites border-none
                    ${
                      errors.confirmPassword && touched.confirmPassword
                        ? "ring-2 ring-red-600 "
                        : null
                    }
                    ${
                      touched.confirmPassword && !errors.confirmPassword
                        ? "ring-2 ring-[#4FF072]"
                        : null
                    }  
                    `}
                />
                {errors?.confirmPassword && touched.confirmPassword && (
                  <small className="text-red-500">
                    {errors.confirmPassword}
                  </small>
                )}
              </div>

              <div className="mb-2">
                <button
                  disabled={signUpLoading || isGettingUser}
                  type="submit"
                  className="w-full px-3 py-2 text-white bg-indigo-600 hover:bg-indigo-600 focus:outline-none duration-100 ease-in-out rounded-3xl hover:shadow-lg"
                >
                  {signUpLoading || isGettingUser ? "loading..." : "Register"}
                </button>
              </div>
              {signUpError ? (
                <p className="text-center text-red-500 my-2">
                  {signUpError.message}
                </p>
              ) : null}

              <div className="text-sm text-center text-gray-400 capitalize">
                By clicking register you agree to the
                <Link to="#">Term Of Service</Link>
                and
                <Link to="#">Privacy Policy</Link>
                including
                <Link to="#">Cookie use</Link>
              </div>
              <div className="text-sm text-center text-gray-400 capitalize mt-2">
                have an account already?
                <Link
                  to="/SignIn"
                  className="font-semibold text-indigo-500 focus:text-indigo-600 focus:outline-none focus:underline"
                >
                  Log in
                </Link>
                .
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
